import { NgClass } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalService } from '@services/modal.service';
import { UserService } from '@services/user.service';
import { CheckboxComponent } from '@shared/elements/checkbox/checkbox.component';
import { CommonButtonComponent } from '@shared/elements/common-button/button.component';
import { MODAL_DETAILS } from '@shared/elements/modal/modal';
import { SvgIconComponent } from '@shared/elements/svg-icon/svg-icon.component';
import { TextFieldComponent } from '@shared/elements/text-field/text-field.component';
import { GridEventAction } from '@shared/grid-helper';
import { Member, NonMember } from '@shared/models/model';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonButtonComponent, TextFieldComponent, CheckboxComponent, NgClass, SvgIconComponent],
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent {
  form = new FormGroup({
    password: new FormControl('', [Validators.minLength(4), Validators.maxLength(60), Validators.required]),
    confirmPassword: new FormControl('', [Validators.minLength(4), Validators.maxLength(60), Validators.required]),
  });

  user?: Member | NonMember;
  type: 'password' | 'text' = 'password';
  showPasswords: boolean = false;

  get match() {
    return this.checkMatch();
  }
  constructor(
    @Inject(MODAL_DETAILS) private modalDetails: { id: number; details: GridEventAction<any> },
    private userService: UserService,
    private modalService: ModalService,
  ) {
    this.user = this.modalDetails?.details?.data;
  }

  getControl(controlName: string): FormControl {
    return this.form.get(controlName) as FormControl;
  }

  toggleType() {
    this.type = this.type === 'password' ? 'text' : 'password';
  }

  getErrorMessage(controlName: string): string {
    const control = this.getControl(controlName);
    if (control.touched) {
      if (control.hasError('required')) {
        return `${controlName} is required.`;
      } else if (control.hasError('minlength')) {
        return `${controlName} is too short`;
      } else if (control.hasError('maxlength')) {
        return `${controlName} is too long`;
      }

      if (controlName === 'confirmPassword' && !this.checkMatch()) {
        return `Passwords do not match`;
      }
    }
    return '';
  }

  checkMatch() {
    return this.getControl('password').value === this.getControl('confirmPassword').value;
  }

  confirm() {
    const data = {
      id: this.user!.id,
      password: this.getControl('password').value,
    };

    this.userService.updatePassword(data).subscribe(() => {
      this.modalService.close(this.modalDetails?.id);
    });
  }
}
